<template>
<div class="row" id="searchFilterBar-row">

  <div class="col" id="searchFilterBar-col">
    <div class="form-group" id="searchFilterBar-formGroup">
      <input type="text"
             class="form-control"
             name="input-relation"
             id="search-relation-number"
             :placeholder="'SEARCH_CASES' | translate"
             v-model="filters.relation"
             v-on:keyup="updateFilters">
    </div>
  </div>

  <div class="col flex-ellipsis-fix" id="searchFilterBar-productLine-colFlex">
    <div class="form-group custom-multiselect" :class="{ 'opened': productlineMultiselectShown }" id="searchFilterBar-productLine-multiselect">
      <span v-if="filters.productLineName.length" class="deselect-all text-warning"
            v-on:click="clearFilter('productLineName')"><i class="fa fa-times" aria-hidden="true"></i></span>
      <div class="custom-select text-truncate" id="search-productline"
            @click.stop="productlineMultiselectShown = !productlineMultiselectShown"
            :title="translatedFilterProductLineArray.length ? translatedFilterProductLineArray.join(', ') : ''">
        {{ translatedFilterProductLineArray.length ? translatedFilterProductLineArray.join(', ') : 'ALL_PRODUCT_LINES' | translate }}
      </div>
      <div class="form-control" v-if="productlineMultiselectShown" id="searchFilterBar-productLine-formControl"
            v-click-outside="hideProductlineMultiselect">
        <div class="custom-control custom-checkbox" v-for="productLineName in enabledProductLines" :key="productLineName" :id="'searchFilterBar-productLine-checkboxDiv-' + productLineName.name">
          <input class="custom-control-input" type="checkbox" :id="'checkbox_'+productLineName.name"
                  :value="productLineName.name" v-model="filters.productLineName" v-on:change="updateFilters">
          <label class="custom-control-label d-block"
                  :for="'checkbox_'+productLineName.name" :title="productLineName.description" :id="'searchFilterBar-productLine-label-' + productLineName.name">
            <span class="d-block text-truncate" :id="'searchFilterBar-productLine-span-' + productLineName.name">{{ productLineName.description }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="col flex-ellipsis-fix" id="searchFilterBar-status-colFlex">
    <div class="form-group custom-multiselect" :class="{ 'opened': statusMultiselectShown }" id="searchFilterBar-status-multiselect">
      <span v-if="filters.status.length" class="deselect-all text-warning"
            v-on:click="clearFilter('status')"><i class="fa fa-times" aria-hidden="true"></i></span>
      <div class="custom-select text-truncate" id="search-status"
            @click.stop="statusMultiselectShown = !statusMultiselectShown"
            :title="translatedFilterStatusArray.length ? translatedFilterStatusArray.join(', ') : ''">
        {{ translatedFilterStatusArray.length ? translatedFilterStatusArray.join(', ') : 'ALL_POLICY_CASE_STATUSES' | translate }}
      </div>
      <div class="form-control" v-if="statusMultiselectShown" id="searchFilterBar-status-formControl"
            v-click-outside="hideStatusMultiselect">
        <div class="custom-control custom-checkbox" v-for="status in policyCaseStatuses" :key="status" :id="'searchFilterBar-status-checkboxDiv-' + status">
          <input class="custom-control-input" type="checkbox" :id="'checkbox_'+status"
                  :value="status" v-model="filters.status" v-on:change="updateFilters">
          <label class="custom-control-label d-block"
                  :for="'checkbox_'+status" :title="status | translate('status')" :id="'searchFilterBar-status-label-' + status">
            <span class="d-block text-truncate" :id="'searchFilterBar-status-span-' + status">{{ status | translate('status') }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="col flex-ellipsis-fix" id="searchFilterBar-batch-colFlex">
    <div class="form-group custom-multiselect" :class="{ 'opened': batchMultiselectShown }" id="searchFilterBar-batch-multiselect">
      <span v-if="filters.batch.length" class="deselect-all text-warning"
            v-on:click="clearFilter('batch')"><i class="fa fa-times" aria-hidden="true"></i></span>
      <div class="custom-select text-truncate" id="search-batch"
            @click.stop="batchMultiselectShown = !batchMultiselectShown"
            :title="filters.batch.length ? filters.batch.join(', ') : ''">
        {{ filters.batch.length ? filters.batch.join(', ') : 'ALL_BATCHES' | translate }}
      </div>
      <div class="form-control" v-if="batchMultiselectShown" id="searchFilterBar-batch-formControl"
            v-click-outside="hideBatchMultiselect">
        <div class="custom-control custom-checkbox" v-for="batchId in availableBatchIds" :key="batchId" :id="'searchFilterBar-batch-checkboxDiv-' + batchId">
          <input class="custom-control-input" type="checkbox" :id="'checkbox_'+batchId"
                  :value="batchId" v-model="filters.batch" v-on:change="updateFilters">
          <label class="custom-control-label d-block"
                  :for="'checkbox_'+batchId" :title="batchId" :id="'searchFilterBar-batch-label-' + batchId">
            <span class="d-block text-truncate" :id="'searchFilterBar-batch-span-' + batchId">{{ batchId }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="col-1 ml-auto" id="searchFilterBar-filterClearButton">
    <button class="btn btn-primary btn-block" v-on:click="clear" id="btn-filter-clear">Wis</button>
  </div>

</div>
</template>

<script>
import GeneralConfigService from '../../service/GeneralConfigService';
import { clickOutsideDirective } from '../../directives/ClickOutside';
import _ from 'lodash';

export default {
  props: ['relation', 'batch', 'loaded', 'productLineName', 'status'],
  data: function() {
    return {
      filters: {
        relation: '',
        batch: [],
        productLineName: [],
        status: []
      },
      availableBatchIds: [],
      enabledProductLines: [],
      policyCaseStatuses: [],
      batchMultiselectShown: false,
      productlineMultiselectShown: false,
      statusMultiselectShown: false
    }
  },
  directives: {
    'click-outside': clickOutsideDirective
  },
  async beforeMount() {
    await this.init();
  },
  computed: {
    translatedFilterStatusArray: function() {
      return this.filters.status.map(status => this.$options.filters.translate(status, 'status'));
    },
    translatedFilterProductLineArray: function() {
      return this.filters.productLineName.map(productLineName => this.getDescriptionByName(productLineName));
    },
    debouncedEmitUpdatedFilters: function() {
      return _.debounce(this.emitUpdatedFilters, 1000);
    }
  },
  methods: {
    updateFilters: function(event) {
      this.debouncedEmitUpdatedFilters();
      if (event.key === 'Enter') this.debouncedEmitUpdatedFilters.flush();
    },
    emitUpdatedFilters: function() {
      this.$emit('input', this.filters);
      this.$emit('filter', this.filters);
    },
    async init() {
      this.availableBatchIds = await GeneralConfigService.getPolicyCaseBatchIds();
      this.enabledProductLines = await GeneralConfigService.getEnabledProductLines();
      this.policyCaseStatuses = await GeneralConfigService.getPolicyCaseStatuses();
      this.filters.relation = this.relation || '';
      this.filters.batch = this.batch ? this.batch.split(',') : [];
      this.filters.productLineName = this.productLineName ? this.productLineName.split(',') : [];
      this.filters.status = this.status ? this.status.split(',') : [];
    },
    clearFilter: function(filter) {
      switch (filter) {
        case 'batch':
          this.filters.batch = [];
          break;
        case 'productLineName':
          this.filters.productLineName = [];
          break;
        case 'status':
          this.filters.status = [];
          break;
      }
      this.debouncedEmitUpdatedFilters();
      this.debouncedEmitUpdatedFilters.flush();
    },
    clear: function() {
      this.filters.relation = '';
      this.filters.batch = [];
      this.filters.productLineName = [];
      this.filters.status = [];
      this.debouncedEmitUpdatedFilters();
      this.debouncedEmitUpdatedFilters.flush();
    },
    hideBatchMultiselect: function() {
      this.batchMultiselectShown = false;
    },
    hideProductlineMultiselect: function() {
      this.productlineMultiselectShown = false;
    },
    hideStatusMultiselect: function() {
      this.statusMultiselectShown = false;
    },
    getDescriptionByName(name) {
      for (let item of this.enabledProductLines) {
        if (item.name === name) {
          return item.description;
        }
      }
      return '-';
    }
  }
}
</script>

<style lang="scss" scoped>
.row > div {
  padding: 0 .75rem;
}
.col:nth-child(1) {
  flex: 0 0 33%;
  max-width: 33%;
}
.col:nth-child(2),
.col:nth-child(3),
.col:nth-child(4) {
  flex: 0 0 11%;
  max-width: 11%;
}
.flex-ellipsis-fix {
  min-width: 0;
}
.form-group {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/cases/SearchFilterBar.vue